export default __webpack_public_path__ + "static/flags-8cbacd2fbec7da24352fc82fc871b9f6.svg";